// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AttachFileIcon from '@mui/icons-material/AttachFile';


class MessageAttachmentCreateModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            button: {
                icon: AttachFileIcon,
                color: 'neutral',
                label: 'Вложение',
                variant: 'plain',
            },
            modalLabel: 'Добавить вложение',
            modalIcon: AttachFileIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            flat: true,
            ready: true,
        })
    }

    async retrieveFields() {
        let formFields = [
            {
                'name': 'upload',
                'label': 'Файл',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': null,
                'type': 'file',
                'maxSize': 300,
            },
            {
                type: 'submit',
                label: 'Создать'
            }
        ]
        return (formFields)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if (this.props.callBack){
            await this.props.callBack(formDataObj.upload)
        }
        this.setModalOpenFalse();
    }
}

export default MessageAttachmentCreateModal